import React from 'react';

export const PortugalMap = () => {
  return (
    <div className="relative w-full h-full min-h-[200px] flex items-center justify-center">
      <div className="relative w-full h-full flex items-center justify-center">
        <img 
          src="/app_images/Portugal_Outline_Map.png" 
          alt="Portugal Map"
          className="w-2/5 h-auto object-contain mx-auto opacity-90 transition-opacity hover:opacity-100"
        />
      </div>
    </div>
  );
};